<template>
  <v-card flat elevation="5">
    <v-lazy
        v-model="lazyActive"
        min-height="400"
        :options="{
        threshold: 0.1,
      }"
        transition="fade-transition"
    >
      <Charts :option="interestDistributed"/>
    </v-lazy>
  </v-card>
</template>

<script>
// import Charts from "@/components/Charts.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  props: {
    chartInfoState: Boolean,
  },
  components: {
    // Charts,
    Charts: () => import("@/components/Charts.vue"),
  },
  methods: {
    ...mapActions("customanalysis", ["updateInterestReport"]),
  },
  computed: {
    ...mapGetters("customanalysis", ["getDistributed"]),
    interestDistributed() {
      const option = this.reportData;
      const report = this.getDistributed; //vuex
      if (report.data) {
        option.title.text = report.chartTitle;
        option.subtitle.text = report.subtitle;
        option.xAxis.categories = report.data.map((el) => el.name);
        option.series[0].data = report.data.map((el) => el.count);
        option.colors = [report.color];
      }
      // this.chartOption = option;
      return option;
    },

  },
  watch: {
    chartInfoState() {
      let exportId = [
        "newVisitors",
        "activeCustomers",
        "potentialCustomers",
        "returningVisitors"];
      if (this.chartInfoState === true) {
        for (let i = 0; i < 4; i++) {
          let option;
          let report;
          this.updateInterestReport(i);
          option = JSON.parse(JSON.stringify(this.reportData));
          report = this.getDistributed; //vuex

          option.title.text = report.chartTitle;
          option.subtitle.text = report.subtitle;
          option.xAxis.categories = report.data.map((el) => el.name);
          option.series[0].data = report.data.map((el) => el.count);
          option.colors = [report.color];

          this.$emit("addChartInfo", {
            data: option,
            id: exportId[i]
          });
        }
      }


    }
  },
  data: () => ({
    chartOption: {},
    lazyActive: false,
    reportData: {
      chart: {
        type: "bar",
      },
      title: {
        text: "",
        style: {
          fontFamily: "Roboto,sans-serif",
        },
      },
      subtitle: {
        text: "",
      },
      xAxis: {
        categories: [],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
      },
      tooltip: {
        valueSuffix: " 人",
      },
      plotOptions: {
        series: {
          cursor: "pointer",
          animation: {
            duration: 400,
            easing: "easeOutBounce",
          },
          colorByPoint: true, // 所有數據列是否都用colors設定數據點顏色

          colors: [
            "#F94144",
            "#F3722C",
            "#F8961E",
            "#F9844A",
            "#F9C74F",
            "#90BE6D",
            "#43AA8B",
            "#4D908E",
            "#577590",
            "#277DA1",
            "#455E89",
            "#5C4D7D",
            "#723C70",
            "#892B64",
            "#A01A58",
          ], // 所有數據列的數據點依序採用陣列中顏色
        },
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: "interest",
          data: [],
        },
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
        // enabled: false,
        // relativeTo: "chart",
        // buttons: {
        //   contextButton: {
        //     menuItems: ["downloadCSV"],
        //   },
        // },
      },
      helpIcon: {
        annotation: "以標籤類別進行排名，每個類別只顯示貼標數最高的標籤",
        enabled: true,
      },
    },
  })
};
</script>
